const LATEST_CHECK_TIMESTAMP_KEY = 'at.ug.latest-check-timestamp';

class LatestCheckStorage {
    set = (latestCheckTimestamp: number) => {
        localStorage.setItem(LATEST_CHECK_TIMESTAMP_KEY, String(latestCheckTimestamp));
    };

    get = (): number | null => {
        return Number(localStorage.getItem(LATEST_CHECK_TIMESTAMP_KEY));
    };

    clear = () => {
        localStorage.removeItem(LATEST_CHECK_TIMESTAMP_KEY);
    };
}

export const latestCheckStorage = new LatestCheckStorage();
